var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57143 1.76727C5.3441 1.76727 5.12608 1.86036 4.96534 2.02608C4.80459 2.19179 4.71429 2.41655 4.71429 2.6509V9.13088C4.71429 9.36524 4.62398 9.58999 4.46323 9.7557C4.30249 9.92142 4.08447 10.0145 3.85714 10.0145C3.62981 10.0145 3.4118 9.92142 3.25105 9.7557C3.09031 9.58999 3 9.36524 3 9.13088V2.6509C3 1.94784 3.27092 1.27357 3.75315 0.776431C4.23539 0.279291 4.88944 0 5.57143 0H10.1429C10.8248 0 11.4789 0.279291 11.9611 0.776431C12.4434 1.27357 12.7143 1.94784 12.7143 2.6509V4C12.7143 4.23435 12.624 4.45911 12.4632 4.62482C12.3025 4.79054 12.0845 4.88363 11.8571 4.88363C11.6298 4.88363 11.4118 4.79054 11.2511 4.62482C11.0903 4.45911 11 4.23435 11 4V2.6509C11 2.41655 10.9097 2.19179 10.7489 2.02608C10.5882 1.86036 10.3702 1.76727 10.1429 1.76727H5.57143Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 8.21826H2.28571C1.02335 8.21826 0 9.27324 0 10.5746V17.6437C0 18.9451 1.02335 20 2.28571 20H13.7143C14.9767 20 16 18.9451 16 17.6437V10.5746C16 9.27324 14.9767 8.21826 13.7143 8.21826Z",
    fill: "#E12D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlockIcon.96102c5259f7511362f46e44175f1a8b.svg";
export { ForwardRef as ReactComponent };